import { FieldErrors, FieldValues } from 'react-hook-form';
import { TFunction } from 'i18next';

type FormValues = {
    password: string;
    confirmPassword: string;
    [key: string]: string;
  };

// Function to determine error state and message
export const getPasswordValidationState = (values: FieldValues,
  errors: FieldValues | FieldErrors<FormValues>,
  isValid: boolean,
  t: TFunction) => {
  const { confirmPassword } = values;
  const { password } = values;
  const passwordsDoNotMatch = confirmPassword && password !== confirmPassword;

  return {
    showError: !isValid && (!!errors?.confirmPassword || passwordsDoNotMatch),
    errorMessage: isValid
      ? ''
      : (errors?.confirmPassword?.message
           || (passwordsDoNotMatch ? t('coverage.errors.confirm_password_error') : '')),
  };
};
